module.exports = __webpack_public_path__ + "components/MapControl/svg/Bank.svg?6b22304c";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Bank.svg
// module id = 1909
// module chunks = 0